export enum DealMode {
    fiMode = 'fiMode',
    deskingMode = 'deskingMode'
}

export const enum DeskingModeCTAText {
    DeskingMode = 'Desking Mode',
    FnIMode = 'Deal Screen'
}

export const enum DeskingModeCTAValue {
    DeskingMode = 'Desking',
    FnIMode = 'F&I'
}
